import h from 'virtual-dom/h';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {HistoryMessage} from "../../../../types/history";
import {VChild} from "virtual-dom";
import LiveChatState from "../livechat-state";


export default class QueuedBanner
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;


    //#region Public Interface

    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    doesRender(message: HistoryMessage): boolean
    {
        return message.type === this._settings.messageConstants.livechatQueuedBanner &&
            this._stateManager.isQueuedStatus(this._stateManager.sessionStatus) &&
            this._stateManager.getCurrentQueueText() !== undefined;
    }

    getRenderer()
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message)) { return []; }

            const queueText = this._stateManager.getCurrentQueueText() as string;

            return h('div', { className: this._settings.classNames.livechat.chatBannerQueuedContainer }, queueText);
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/queued-banner.ts